import * as React from "react";
import { createContext, useContext } from "react";
const Context = createContext(false);
export const useWaitFor = () => useContext(Context);
export const WaitFor = ({ input, resource, children }) => {
    const { resolved } = resource.use(input);
    return React.createElement(Context.Provider, { value: !resolved }, children);
};
//# sourceMappingURL=WaitFor.js.map